module.exports = __webpack_public_path__ + "img/20.6bf0ea7e.jpg";